import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BreadcrumbModule } from 'primeng/breadcrumb';

import { SharedModule } from '../shared/shared.module';
import { BreadcrumbComponent } from './breadcrumb.component';

@NgModule({
    imports: [
      FormsModule,
      BreadcrumbModule,
      SharedModule
    ],
    declarations: [
      BreadcrumbComponent
    ],
    exports: [
      BreadcrumbComponent
    ]
  })
  export class BreadcrumbSDSModule {
  }

